import React from 'react';
import './StageFilters.css';

interface StageFiltersProps {
  value: string;
  onChange: (v: string) => void;
  options: string[];
}

const StageFilters: React.FC<StageFiltersProps> = ({ value, onChange, options }) => (
  <div className="stage-filters">
    {options.map((o) => (
      <button key={o} className={`stage-filter ${o===value?'active':''}`} onClick={() => onChange(o)}>
        {o}
      </button>
    ))}
  </div>
);

export default StageFilters;
